/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div class="before"></div>\n' +
((__t = ( form_group_for(model, 'ApplicationKey', 'Key', 'text', {
    input: {'readonly': 'readonly', 'class': 'key'}    
}))) == null ? '' : __t) +
'\n\n<div class="form-group">\n    ' +
((__t = ( label_for(model, 'Secret', 'Secret', {
        'class': 'control-label'
    }))) == null ? '' : __t) +
'\n    ' +
((__t = ( input_for(model, 'Secret', 'password', {
        'class': 'form-control secret',
        'readonly': 'readonly'
    }))) == null ? '' : __t) +
'\n    ';
 if(!model.isNew()){;
__p += '\n        <div class="col-sm-4">\n            <button type="button" class="btn btn-default show-secret">Show Secret</button>\n            <button type="button" class="btn btn-default reset-secret">Reset Secret</button>\n       </div>\n    ';
};
__p += '\n</div>\n<div class="after"></div>';

}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/admin/plugins/Form.ejs
// module id = 934
// module chunks = 1